import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Execute from 'components/inspection/modal/execute';
import { InspectionResultLink } from 'utils/link';

const ExecuteButton = ({ inspection, space, refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();
  const navigate = useNavigate();

  return (
    <Button
      disabled={!space.inspectorRole}
      color="success"
      variant="contained"
      onClick={() => {
        addModal(
          <Execute
            inspection={inspection}
            onSuccess={(inspectionResult) => {
              refetch?.();
              removeModal();
              setInfo('info.inspection.executed');
              navigate(InspectionResultLink(inspectionResult.id));
            }}
            handleClose={() => removeModal()}
          />,
          { disableAutoFocus: true, disableRestoreFocus: true }
        );
      }}
    >
      <FormattedMessage id="button.execute" />
    </Button>
  );
};

export default ExecuteButton;
